var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card title"},[_c('div',{staticClass:"card-body title-body p-3"},[_c('h3',{staticClass:"tile-title is-line mb-2"},[_vm._v(" Cài đặt Email ")]),_c('user-email')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }